import { Component,ViewChild,ViewChildren,ElementRef,QueryList} from '@angular/core';
import { Content,App} from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';
import { pinyin } from '../../../../../providers/service/pinyin';
import { AddressBookInfo } from '../detail/addressbookinfo';

@Component({
  selector: 'addressbook-list',
  templateUrl: 'addressbooklist.html'
})

export class AddressBookList {
	addressBookList:any[];
	initialsArray:any=[];
	showAddressBookData:any=[];
	@ViewChild(Content) content: Content;
	@ViewChildren('initialsGroup')
  initialsName: QueryList<ElementRef>;
	constructor(public global: AppState,public appCtrl: App) {
	  this.addressBookList = [
		  {'name':'张三','telephone':"12309345876"},
		  {'name':'张一','telephone':"12309345872"},
		  {'name':'张二','telephone':"12309345873"},
		  {'name':'李四','telephone':"15309345856"},
		  {'name':'王五','telephone':"15309345336"},
		  {'name':'王东','telephone':"15309345336"},
		  {'name':'陈政','telephone':"15309345336"},
		  {'name':'程明','telephone':"15309345336"},
		  {'name':'冯红','telephone':"15309345336"},
		  {'name':'金去','telephone':"15309345336"},
		  {'name':'赵张红','telephone':"15309345336"},
		  {'name':'andy','telephone':"66488833"},
		  {'name':'marry','telephone':"9999999"}
	  ];
    let translatedData = this.translate(this.addressBookList);
    let sortedData = this.translatedDataSort(translatedData);
  	this.arrangeList(sortedData);
	}
	
	translatedDataSort(translatedList){
		let sortedData = translatedList.sort(
  		(a: any, b: any) => 
  		{
  			if (a.pinyinName < b.pinyinName) {
  				return -1;
  			} else if (a.pinyinName > b.pinyinName) {
  				return 1;
  			} else {
		        return 0;
  			}
  	});
  	return sortedData;
	}
	translate(initiallist){
		if(initiallist != null){
			let reg = /^[A-Za-z]+$/; //如果首字符不是字母都单独处理
			let reg1 = /^[a-zA-Z]*$/;//验证是否为英文
			for(let i = 0; i < initiallist.length; i++){
				if(initiallist[i].name == null || initiallist[i].name == ''){
					initiallist[i].initials = '#';
					initiallist[i].pinyinName = '';
				}else{
					 if(reg1.test(initiallist[i].name)){
					 	initiallist[i].pinyinName = initiallist[i].name.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
					 }else{
					 	initiallist[i].pinyinName = pinyin.getFullChars(initiallist[i].name);
					 }
					initiallist[i].initials = initiallist[i].pinyinName.substring(0, 1);
					if(!reg.test(initiallist[i].initials)){//如果首字符不是字母 进入 # 分类
	  				  initiallist[i].initials = '#';
					}
				}
			}
		}
		return initiallist;
	}
	arrangeList(sortedData){
		let items = [];
		let mapData = {};
		this.initialsArray = [];
		this.showAddressBookData = [];
		for(let i = 0; i < sortedData.length; i++){
			let ini = sortedData[i].initials;
			if(this.initialsArray.indexOf(ini) < 0){
				this.initialsArray.push(ini);
				items = [];
				items.push(sortedData[i]);
				mapData[ini] = items;
			}else{
				mapData[ini].push(sortedData[i]);
			}
		}
		for(let key in mapData){
			let item = {"initials":key,"addressBookList":mapData[key]};
			this.showAddressBookData.push(item);
		}
	} 
  scrollToAims($event,i){
  	let offsetTop = 0;
  	if(i == -1){
  		offsetTop = 0;
  	  $event.style.color="#3b99fc";
  	  let elem = $event.parentNode.firstChild;
  	  for ( ; elem; elem = elem.nextSibling ) {
  	  	if ( elem.nodeType === 1 && elem !== $event) {
  	  		  elem.style.color="#666";
  	  	  }
  	  }
  	}else{
  		$event.target.style.color="#3b99fc";
  	  offsetTop = this.initialsName["_results"][i].nativeElement.offsetTop;
  	  let elem = $event.target.parentNode.firstChild;
  	  for ( ; elem; elem = elem.nextSibling ) {
  	    if ( elem.nodeType === 1 && elem !== $event.target ) {
  		   elem.style.color="#666";
  	    }
      }
  	}
  	this.content.scrollTo(0, offsetTop, 200);
  }
  
  searchAddressBook($event){
  	let keyword = $event.data;
  	let filterData = [];
  	if(keyword == "" || keyword == null){
  		filterData = [];
  		filterData =this.addressBookList;
  	}else{
  		for(let i = 0 ; i < this.addressBookList.length;i++){
  		  let name = this.addressBookList[i].name;
  		  let phone = this.addressBookList[i].telephone;
  		  if(new RegExp(keyword).test(name) ||new RegExp(keyword).test(phone)){
  			  filterData.push(this.addressBookList[i]);
  		  }
  		}
  	}
  	let translatedData = this.translate(filterData);
    let sortedData = this.translatedDataSort(translatedData);
  	this.arrangeList(sortedData);
  }
  
  openAddressBookDetail(item){
  		this.appCtrl.getRootNav().push(AddressBookInfo,item);
  }
	
}


// WEBPACK FOOTER //
// ./src/pages/application/dailyoffice/addressbook/list/addressbooklist.ts